import { useAccount } from "wagmi";
import { useShipBalance, useUsdcBalance } from "../../hooks";
import { StatCard } from "../shared";

export function FleetHero() {
	const { address } = useAccount();
	const { balance: totalShips } = useShipBalance(address);
	const { formattedBalance: usdcBalance } = useUsdcBalance(address);

	return (
		<div className="fleet-hero">
			<StatCard
				icon="🛸"
				label="Total Ships"
				value={String(totalShips)}
				accent="var(--color-cyan)"
			/>
			<StatCard
				icon="💰"
				label="USDC Balance"
				value={`${Number.parseFloat(usdcBalance).toFixed(2)}`}
				accent="var(--color-green)"
			/>
		</div>
	);
}
